export default __webpack_public_path__ + "static/media/USA.ec4754c6.svg";